import h from 'react-hyperscript';

import './FeaturedWork.css';

import Section from '../../Section';

const Rows = [
  {
    title: 'Magic of Theme Development',
    desc:
      'Proin iaculis purus consequat sem cure digni ssim. Donec porttitora entum suscipit aenean rhoncus posuere odio in tincidunt.',
    iconClass: '.fa.fa-magic',
  },
  {
    title: 'Neatly Packaged',
    desc:
      'Proin iaculis purus consequat sem cure digni ssim. Donec porttitora entum suscipit aenean rhoncus posuere odio in tincidunt.',
    iconClass: '.fa.fa-gift',
  },
  {
    title: 'SEO Optimized',
    desc:
      'Proin iaculis purus consequat sem cure digni ssim. Donec porttitora entum suscipit aenean rhoncus posuere odio in tincidunt.',
    iconClass: '.fa.fa-dashboard',
  },
].map(row => {
  const { title, desc, iconClass } = row;

  return h('.featured-box', { key: title }, [
    h('.featured-box-col1.wow.fadeInRight.delay-02s', [h(`i${iconClass}`)]),
    h('.featured-box-col2.wow.fadeInRight.delay-02s', [h('h3', title), h('p', desc)]),
  ]);
});

const FeaturedWork = () =>
  h(Section, { className: 'alabaster' }, [
    h('div'),
    h('.row', [
      h('figure.col-lg-5.col-sm-4.wow.fadeInLeft', [h('img', { src: 'img/iphone.png', alt: 'iPhone' })]),
      h('.col-lg-7.col-sm-8.featured-work', [
        h('h2', 'Featured Work'),
        h(
          'p.padding-b',
          `Proin iaculis purus consequat sem cure digni ssim. Donec porttitora entum suscipit aenean rhoncus posuere odio in tincidunt.
          Proin iaculis purus consequat sem cure digni ssim. Donec porttitora entum suscipit.`,
        ),
        ...Rows,
      ]),
    ]),
  ]);

export default FeaturedWork;

// <section class="main-section" id="service"><!--main-section-start-->
//   <div class="container">
//     <h2>Services</h2>
//     <h6>We offer exceptional service with complimentary hugs.</h6>
//     <div class="row">
//       <div class="col-lg-4 col-sm-6 wow fadeInLeft delay-05s">
//         <div class="service-list">
//           <div class="service-list-col1">
//             <i class="fa-paw"></i>
//           </div>
//           <div class="service-list-col2">
//             <h3>branding &amp; identity</h3>
//             <p>Proin iaculis purus digni consequat sem digni ssim. Donec entum digni ssim.</p>
//           </div>
//         </div>
//         <div class="service-list">
//           <div class="service-list-col1">
//             <i class="fa-gear"></i>
//           </div>
//           <div class="service-list-col2">
//             <h3>web development</h3>
//             <p>Proin iaculis purus consequat sem digni ssim. Digni ssim porttitora .</p>
//           </div>
//         </div>
//         <div class="service-list">
//           <div class="service-list-col1">
//             <i class="fa-apple"></i>
//           </div>
//           <div class="service-list-col2">
//             <h3>mobile design</h3>
//             <p>Proin iaculis purus consequat digni sem digni ssim. Purus donec porttitora entum.</p>
//           </div>
//         </div>
//         <div class="service-list">
//           <div class="service-list-col1">
//             <i class="fa-medkit"></i>
//           </div>
//           <div class="service-list-col2">
//             <h3>24/7 Support</h3>
//             <p>Proin iaculis purus consequat sem digni ssim. Sem porttitora entum.</p>
//           </div>
//         </div>
//       </div>
//       <figure class="col-lg-8 col-sm-6  text-right wow fadeInUp delay-02s">
//         <img src="img/macbook-pro.png" alt="">
//       </figure>
//
//     </div>
//   </div>
// </section><!--main-section-end-->



// WEBPACK FOOTER //
// ./src/components/Sections/FeaturedWork/FeaturedWork.js